(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vermart-mobile-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vermart-mobile-collection')) {
  customElements.define('vermart-mobile-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const form = this.querySelector('form');
      const sortSelect = this.querySelector('select[name="sort_by"]');
      if (!form || !sortSelect) return;
      sortSelect.addEventListener('focus', () => {
        const currentSort = new URLSearchParams(window.location.search).get('sort_by');
        if (currentSort && Array.from(sortSelect.options).some(option => option.value === currentSort)) sortSelect.value = currentSort;
      }, { signal });
      sortSelect.addEventListener('change', () => form.requestSubmit(), { signal });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
      }, { signal });
      const panel = this.querySelector('.vermart-filter-panel');
      const dialog = this.querySelector('.vermart-filter-dialog');
      const mobile = window.matchMedia('(max-width: 767px)');
      if (panel && dialog && typeof dialog.showModal === 'function') {
        const fields = panel.querySelector('.vermart-filter-fields');
        if (fields) dialog.append(fields);
        panel.hidden = true;
        this.classList.add('is-enhanced');
        let opener = null;
        const resetPending = () => {
          dialog.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = input.defaultChecked; });
          dialog.querySelectorAll('input[type="number"]').forEach(input => { input.value = input.defaultValue; input.disabled = false; });
          dialog.querySelectorAll('[data-brand-search]').forEach(input => { input.value = ''; input.dispatchEvent(new Event('input')); });
        };
        dialog.addEventListener('close', () => {
          resetPending();
          if (mobile.matches && opener && opener.isConnected) opener.focus();
        }, { signal });
        dialog.querySelector('[data-close-filter]').addEventListener('click', () => dialog.close(), { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, { signal });
        mobile.addEventListener('change', event => { if (!event.matches && dialog.open) dialog.close(); }, { signal });
        this.querySelectorAll('[data-filter-jump]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            if (!mobile.matches) return;
            opener = button;
            const group = button.dataset.filterJump === 'all'
              ? dialog.querySelector('[data-brand-group], .vermart-filter-group')
              : this.querySelector(`#${CSS.escape(button.dataset.filterJump)}`);
            if (group) group.open = true;
            if (!dialog.open) dialog.showModal();
            if (button.dataset.filterJump !== 'all' && group) {
              const focusTarget = group.querySelector('[data-brand-search]') || group.querySelector('summary');
              focusTarget.focus();
            }
          }, { signal });
        });
        dialog.querySelectorAll('[data-brand-search]').forEach(input => {
          input.closest('.vermart-brand-search').hidden = false;
          input.addEventListener('input', () => {
            const query = input.value.trim().toLocaleLowerCase();
            const group = input.closest('.vermart-filter-group');
            let visible = 0;
            group.querySelectorAll('[data-filter-value]').forEach(row => {
              row.hidden = !row.dataset.filterValue.toLocaleLowerCase().includes(query);
              if (!row.hidden) visible += 1;
            });
            group.querySelector('.vermart-brand-empty').hidden = visible > 0;
          }, { signal });
          input.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); }, { signal });
        });
      }
      const nav = this.closest('.vermart-mobile-collection')?.querySelector('nav[aria-label="Shop by category"]');
      const toggle = this.querySelector('.vermart-category-toggle');
      if (nav && toggle && nav.children.length > 1) {
        nav.classList.remove('is-expanded');
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = toggle.dataset.expandLabel;
        nav.id = nav.id || `${sortSelect.id}-categories`;
        toggle.setAttribute('aria-controls', nav.id);
        toggle.addEventListener('click', () => {
          const expanded = nav.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
        }, { signal });
      }
    }
    disconnectedCallback() {
      const dialog = this.querySelector('.vermart-filter-dialog');
      if (dialog?.open) dialog.close();
      this.controller?.abort();
      delete this.dataset.ready;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
